import { Box, Flex } from "orcs-design-system";

import * as placeholder from "src/components/Placeholder/PlaceholderStyles";

/** Same row count as global search placeholder sections (`PLACEHOLDER_COUNT`). */
export const INBOX_LIST_SKELETON_COUNT = 3;

const InboxListSkeletonRow = () => (
  <Box
    p="s"
    bg="surface"
    boxBorder="default"
    borderRadius={2}
    data-testid="inbox-list-skeleton-row"
    aria-hidden="true"
  >
    <Flex alignItems="flex-start" gap="xs" justifyContent="space-between">
      <Flex flexDirection="column" gap="xs" flex="1" minWidth={0}>
        <placeholder.Line width={120} height={14} />
        <placeholder.Line width={200} height={18} />
        <placeholder.Line width={160} height={14} />
      </Flex>
      <Flex
        flexDirection="column"
        gap="xs"
        alignItems="flex-end"
        flexShrink={0}
      >
        <placeholder.Line width={48} height={14} />
      </Flex>
    </Flex>
  </Box>
);

const InboxListSkeleton = () => (
  <Flex
    flexDirection="column"
    gap="s"
    width="100%"
    data-testid="inbox-list-skeleton"
    role="status"
    aria-label="Loading inbox items"
    aria-busy="true"
  >
    {Array.from({ length: INBOX_LIST_SKELETON_COUNT }, (_, index) => (
      <InboxListSkeletonRow key={index} />
    ))}
  </Flex>
);

export default InboxListSkeleton;
